<template>
  <div class="collateral-item-page">
    <div class="collateral-item-page__breadcrumbs collateral-item-page__breadcrumbs_mobile">
      <a class="collateral-item-page__breadcrumb" href="/property/">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="3" fill="#252628"/>
        </svg>
        <span>Залоговая недвижимость</span></a>
      <a class="collateral-item-page__breadcrumb" :href="data.region.region_link">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="3" fill="#252628"/>
        </svg>
        <span>{{data.region.name}}</span></a>
    </div>
    <div class="collateral-item-page__container">
      <div class="collateral-item-page__block-swiper">
        <swiper
            @slideChange="slideChange"
            :thumbs="{ swiper: thumbsSwiper }"
            :effect="'fade'"
            :modules="modules"
            :speed="2000"
            :navigation="{nextEl: '.collateral-item-page__swiper-navigation-next', prevEl: '.collateral-item-page__swiper-navigation-prev', disabledClass: 'disabled'}"
            :autoplay="{delay: 3000, disableOnInteraction: false}"
            class="collateral-item-page__swiper">
          <template v-if="data.props.photos">
            <swiper-slide
              v-for="(item, index) in data.props.photos"
              :key="index"
              class="collateral-item-page__swiper-slide">
              <img
                v-if="item.src"
                :src="item.src"
                :width="item.width"
                :height="item.height" />
              <picture v-else>
                <source
                  type="image/webp"
                  srcset="/static/v2/src/img/land/empty-img.webp"/>
                <img
                  src="/static/v2/src/img/land/empty-img.jpg"
                  alt="Фотография объекта"
                  title="Фотография объекта"
                  width="780"
                  height="585" />
              </picture>
            </swiper-slide>
          </template>
          <swiper-slide v-else>
            <picture>
                <source
                  type="image/webp"
                  srcset="/static/v2/src/img/land/empty-img.webp"/>
                <img
                  src="/static/v2/src/img/land/empty-img.jpg"
                  alt="Фотография объекта"
                  title="Фотография объекта"
                  width="780"
                  height="585" />
              </picture>
          </swiper-slide>
        </swiper>
        <p class="collateral-item-page__swiper-score">{{ sliderIndex }}/{{data.props.photos?.length}}</p>
        <a
            class="collateral-item-page__favorite"
            href="#"
            title="В избранное"
            @click.prevent.stop="favoriteHandler">
          <svg
              v-show="!isFavorite"
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.64066 1.66208C10.1665 1.44418 10.7302 1.33203 11.2994 1.33203C11.8687 1.33203 12.4323 1.44418 12.9582 1.66208C13.484 1.87994 13.9617 2.19923 14.3641 2.60173C14.7666 3.0041 15.0861 3.48204 15.3039 4.00782C15.5218 4.53369 15.634 5.09735 15.634 5.66658C15.634 6.23582 15.5218 6.79947 15.3039 7.32535C15.0861 7.85117 14.7667 8.32893 14.3642 8.73132L8.47083 14.6247C8.21048 14.885 7.78837 14.885 7.52802 14.6247L1.63469 8.73132C0.821871 7.9185 0.365234 6.81608 0.365234 5.66658C0.365234 4.51708 0.821871 3.41466 1.63469 2.60184C2.44751 1.78902 3.54993 1.33239 4.69943 1.33239C5.84893 1.33239 6.95135 1.78902 7.76417 2.60184L7.99943 2.83711L8.23458 2.60195C8.63697 2.1994 9.11483 1.87996 9.64066 1.66208ZM11.2994 2.66536C10.9053 2.66536 10.5151 2.74301 10.1511 2.89386C9.78698 3.04471 9.4562 3.26582 9.17761 3.54454L8.47083 4.25132C8.21048 4.51167 7.78837 4.51167 7.52802 4.25132L6.82136 3.54465C6.25859 2.98188 5.49531 2.66572 4.69943 2.66572C3.90355 2.66572 3.14027 2.98188 2.5775 3.54465C2.01473 4.10742 1.69857 4.8707 1.69857 5.66658C1.69857 6.46246 2.01473 7.22574 2.5775 7.78851L7.99943 13.2104L13.4214 7.78851C13.7001 7.50992 13.9213 7.17903 14.0721 6.81496C14.223 6.45089 14.3006 6.06067 14.3006 5.66658C14.3006 5.2725 14.223 4.88228 14.0721 4.51821C13.9213 4.15414 13.7002 3.82336 13.4215 3.54476C13.1429 3.26604 12.8119 3.04471 12.4478 2.89386C12.0837 2.74301 11.6935 2.66536 11.2994 2.66536Z" fill="#252628"/>
          </svg>
          <svg
              v-show="isFavorite"
              xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.462 0.493732C15.2508 0.166886 16.0963 -0.00134277 16.9501 -0.00134277C17.804 -0.00134277 18.6494 0.166886 19.4383 0.493732C20.2269 0.820519 20.9435 1.29946 21.5471 1.90321C22.1508 2.50676 22.6301 3.22367 22.9569 4.01234C23.2837 4.80115 23.4519 5.64663 23.4519 6.50048C23.4519 7.35433 23.2837 8.19982 22.9569 8.98863C22.6301 9.77737 22.1511 10.494 21.5472 11.0976L12.7072 19.9376C12.3167 20.3281 11.6835 20.3281 11.293 19.9376L2.45301 11.0976C1.23378 9.87836 0.548828 8.22473 0.548828 6.50048C0.548828 4.77623 1.23378 3.1226 2.45301 1.90338C3.67224 0.684148 5.32587 -0.000808001 7.05012 -0.000808001C8.77437 -0.000808001 10.428 0.684148 11.6472 1.90338L12.0001 2.25627L12.3528 1.90354C12.9564 1.29972 13.6732 0.820549 14.462 0.493732Z" fill="#82BF00"/>
          </svg>
        </a>
        <div
            v-if="data.props.lot_status || data.props.condition"
            class="collateral-item-page__labels">
          <div
              v-if="data.props.lot_status === 'announced'"
              class="collateral-item-page__auction">
            Объявленный аукцион
          </div>
          <div
              v-if="data.props.lot_status === 'planned'"
              class="collateral-item-page__auction collateral-item-page__auction--planned">
            Планируемый аукцион
          </div>
          <div
              v-if="data.props.condition"
              class="collateral-item-page__condition">
            <span>С обременением</span>
            <div class="collateral-item-page__tooltip">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <g clip-path="url(#clip0_1326_30231)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.583984 6.99967C0.583984 10.5435 3.45682 13.4163 7.00065 13.4163C10.5445 13.4163 13.4173 10.5435 13.4173 6.99967C13.4173 3.45585 10.5445 0.583008 7.00065 0.583008C3.45682 0.583008 0.583984 3.45585 0.583984 6.99967ZM12.2506 6.99969C12.2506 9.89918 9.90014 12.2497 7.00064 12.2497C4.10115 12.2497 1.75064 9.89918 1.75064 6.99969C1.75064 4.10019 4.10115 1.74969 7.00064 1.74969C9.90014 1.74969 12.2506 4.10019 12.2506 6.99969Z" fill="#252628"/>
                  <path d="M6.53211 8.17602C6.53211 7.93968 6.58283 7.71945 6.68428 7.51534C6.78573 7.31123 6.90854 7.13666 7.0527 6.99163C7.19687 6.8466 7.34103 6.70963 7.4852 6.58072C7.62936 6.44643 7.75217 6.30141 7.85362 6.14564C7.95507 5.98449 8.00579 5.81529 8.00579 5.63804C8.00579 5.36947 7.91235 5.16536 7.72547 5.0257C7.54393 4.88067 7.30633 4.80816 7.01266 4.80816C6.42532 4.80816 6.04889 5.06867 5.88337 5.5897L5.25064 5.23518C5.38413 4.85919 5.61106 4.5745 5.93142 4.38113C6.25179 4.18239 6.61487 4.08302 7.02067 4.08302C7.49588 4.08302 7.90167 4.2173 8.23806 4.48587C8.57978 4.75444 8.75064 5.12776 8.75064 5.60581C8.75064 5.83141 8.69992 6.04358 8.59847 6.24232C8.49702 6.44106 8.37422 6.61295 8.23005 6.75797C8.08589 6.903 7.94172 7.04534 7.79756 7.185C7.65339 7.31928 7.53058 7.47237 7.42913 7.64425C7.32768 7.81077 7.27696 7.98802 7.27696 8.17602H6.53211ZM6.90053 9.91635C6.75637 9.91635 6.63356 9.86532 6.53211 9.76327C6.43066 9.66121 6.37994 9.53767 6.37994 9.39264C6.37994 9.24761 6.43066 9.12407 6.53211 9.02202C6.63356 8.91996 6.75637 8.86893 6.90053 8.86893C7.05003 8.86893 7.17284 8.91996 7.26895 9.02202C7.3704 9.12407 7.42112 9.24761 7.42112 9.39264C7.42112 9.53767 7.3704 9.66121 7.26895 9.76327C7.17284 9.86532 7.05003 9.91635 6.90053 9.91635Z" fill="#252628"/>
                </g>
                <defs>
                  <clipPath id="clip0_1326_30231">
                    <rect width="14" height="14" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <div class="collateral-item-page__tooltip-text">
                Объекты, в которых зарегистрированы и/или проживают третьи лица. Такие объекты реализуются со скидкой.
              </div>
            </div>
          </div>
        </div>
        <swiper
            @swiper="setThumbsSwiper"
            :slidesPerView="'auto'"
            :allowTouchMove="true"
            :watchSlidesProgress="true"
            :modules="modules"
            :spaceBetween="16"
            class="collateral-item-page__swiper-pagination">
          <swiper-slide class="collateral-item-page__swiper-slide-pagination" v-for="(item, index) in data.props.photos" :key="index">
            <img :src="item.src" :width="item.width" :height="item.height"/>
          </swiper-slide>
        </swiper>
        <div class="collateral-item-page__swiper-navigation">
          <button class="collateral-item-page__swiper-navigation-prev"><span></span><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2071 12.6722C20.5976 12.3009 20.5976 11.6991 20.2071 11.3278L13.8431 5.27842C13.4526 4.90719 12.8195 4.90719 12.4289 5.27842C12.0384 5.64964 12.0384 6.25151 12.4289 6.62273L17.0858 11.0494H4.5C3.94772 11.0494 3.5 11.475 3.5 12C3.5 12.525 3.94772 12.9506 4.5 12.9506H17.0858L12.4289 17.3773C12.0384 17.7485 12.0384 18.3504 12.4289 18.7216C12.8195 19.0928 13.4526 19.0928 13.8431 18.7216L20.2071 12.6722Z" fill="#252628"/>
          </svg></button>
          <button class="collateral-item-page__swiper-navigation-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2071 12.6722C20.5976 12.3009 20.5976 11.6991 20.2071 11.3278L13.8431 5.27842C13.4526 4.90719 12.8195 4.90719 12.4289 5.27842C12.0384 5.64964 12.0384 6.25151 12.4289 6.62273L17.0858 11.0494H4.5C3.94772 11.0494 3.5 11.475 3.5 12C3.5 12.525 3.94772 12.9506 4.5 12.9506H17.0858L12.4289 17.3773C12.0384 17.7485 12.0384 18.3504 12.4289 18.7216C12.8195 19.0928 13.4526 19.0928 13.8431 18.7216L20.2071 12.6722Z" fill="#252628"/>
          </svg><span></span></button>
        </div>
      </div>
      <div class="collateral-item-page__block-information">
        <div class="collateral-item-page__breadcrumbs">
          <a class="collateral-item-page__breadcrumb" href="/property/">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="3" fill="#252628"/>
            </svg>
            <span>Залоговая недвижимость</span></a>
          <a class="collateral-item-page__breadcrumb" :href="data.region.region_link">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="3" fill="#252628"/>
            </svg>
            <span>{{data.region.name}}</span></a>
        </div>
        <h1 class="collateral-item-page__title">{{ data.name }}</h1>
        <a class="collateral-item-page__type" :href="data.props.object_type_link">{{data.props.object_type_ru}}</a>
        <div class="collateral-item-page__block-price">
          <p class="collateral-item-page__price">{{formatNumbers(data.props.price)}} ₽</p>
          <p class="collateral-item-page__price collateral-item-page__price_old" v-if="data.props.old_price"> {{formatNumbers(data.props.old_price)}} ₽</p>
        </div>
        <p class="collateral-item-page__rub-per-sqm">{{formatNumbers(data.props.rub_per_sqm)}} ₽/м<span><sup>2</sup></span></p>
        <div class="collateral-item-page__block-price-history" v-if="data.price_history">
          <button class="collateral-item-page__price-history-title" :class="priceContainerActive ? 'collateral-item-page__price-history-title_active' : ''" @click="setPriceActive">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.37 7.30235C8.37 6.73199 7.89632 6.28 7.325 6.28C6.80073 6.28 6.35987 6.65965 6.28964 7.16308L6.28753 7.17825L6.27947 7.30235L6.28 16.6977C6.28 17.268 6.75368 17.72 7.325 17.72C7.84927 17.72 8.29014 17.3404 8.36036 16.8369L8.36248 16.8217L8.37053 16.6977L8.37 7.30235ZM17.72 9.52145C17.72 8.94538 17.2512 8.48 16.675 8.48C16.1465 8.48 15.7089 8.87108 15.6395 9.38029L15.6375 9.39512L15.6295 9.52145L15.63 16.6785C15.63 17.2546 16.0988 17.72 16.675 17.72C17.2035 17.72 17.6411 17.3289 17.7105 16.8197L17.7125 16.8049L17.7205 16.6785L17.72 9.52145ZM12.0295 11.7764C11.5116 11.7714 11.0779 12.149 11.0047 12.6472L11.0025 12.662L10.9934 12.7853L10.9551 16.6873C10.9494 17.2518 11.4058 17.7108 11.9704 17.7164C12.4883 17.7214 12.9221 17.3438 12.9953 16.8456L12.9975 16.8308L13.0066 16.7075L13.0449 12.8055C13.0506 12.241 12.5941 11.782 12.0295 11.7764Z" fill="#82BF00"/>
              <path d="M4.36111 1C2.50482 1 1 2.50482 1 4.36111V19.6389C1 21.4952 2.50482 23 4.36111 23H19.6389C21.4952 23 23 21.4952 23 19.6389V4.36111C23 2.50482 21.4952 1 19.6389 1H4.36111ZM5.04201 3.20211H18.9892C19.8329 3.20211 20.8466 4.16007 20.8466 5.00384V18.9882C20.8466 19.8319 19.7453 20.8095 18.9015 20.8095H5.13214C4.28838 20.8095 3.20915 19.8416 3.20915 18.9978V5.00384C3.20915 4.16007 4.19824 3.20211 5.04201 3.20211Z" fill="#82BF00"/>
            </svg>
            <span>Изменение цены</span>
          </button>
          <div class="collateral-item-page__price-history-container" v-if="priceContainerActive">
            <div class="collateral-item-page__price-history-card" v-for="(item, index) in data.price_history" :key="index">
              <p class="collateral-item-page__price-history-time">{{item.date}}</p>
              <p class="collateral-item-page__price-history-price">{{formatNumbers(item.price)}} ₽</p>
              <p class="collateral-item-page__price-history-old-price">{{checkDiff(item.diff)}} </p>
            </div>
          </div>
        </div>
        <div class="collateral-item-page__character">
          <p class="collateral-item-page__character-block" v-if="data.props.rooms">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15.4995 16.4984C15.4995 15.9461 15.9472 15.4984 16.4995 15.4984H17.9995C18.5518 15.4984 18.9995 15.9461 18.9995 16.4984C18.9995 17.0507 18.5518 17.4984 17.9995 17.4984H16.4995C15.9472 17.4984 15.4995 17.0507 15.4995 16.4984Z" fill="#252628"/>
              <path d="M16.4995 11.7484C15.9472 11.7484 15.4995 12.1961 15.4995 12.7484C15.4995 13.3007 15.9472 13.7484 16.4995 13.7484H17.9995C18.5518 13.7484 18.9995 13.3007 18.9995 12.7484C18.9995 12.1961 18.5518 11.7484 17.9995 11.7484H16.4995Z" fill="#252628"/>
              <path d="M5.99951 5.74841C5.44723 5.74841 4.99951 6.19613 4.99951 6.74841C4.99951 7.3007 5.44723 7.74841 5.99951 7.74841H8.99951C9.5518 7.74841 9.99951 7.3007 9.99951 6.74841C9.99951 6.19613 9.5518 5.74841 8.99951 5.74841H5.99951Z" fill="#252628"/>
              <path d="M6.49951 12.7484C6.49951 12.1961 6.94723 11.7484 7.49951 11.7484H10.4995C11.0518 11.7484 11.4995 12.1961 11.4995 12.7484C11.4995 13.3007 11.0518 13.7484 10.4995 13.7484H7.49951C6.94723 13.7484 6.49951 13.3007 6.49951 12.7484Z" fill="#252628"/>
              <path d="M5.99951 15.4984C5.44723 15.4984 4.99951 15.9461 4.99951 16.4984C4.99951 17.0507 5.44723 17.4984 5.99951 17.4984H8.99951C9.5518 17.4984 9.99951 17.0507 9.99951 16.4984C9.99951 15.9461 9.5518 15.4984 8.99951 15.4984H5.99951Z" fill="#252628"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.74951 1.99841C3.28538 1.99841 2.84026 2.18279 2.51207 2.51098C2.18389 2.83917 1.99951 3.28428 1.99951 3.74841V19.2484H1.5C0.947715 19.2484 0.5 19.6961 0.5 20.2484C0.5 20.8007 0.947715 21.2484 1.5 21.2484L2.99951 21.2484H13.4995L22.5 21.2484C23.0523 21.2484 23.5 20.8007 23.5 20.2484C23.5 19.6961 23.0523 19.2484 22.5 19.2484H21.9995V9.74841C21.9995 9.28429 21.8151 8.83917 21.4869 8.51098C21.1588 8.18279 20.7136 7.99841 20.2495 7.99841H14.4995V3.74841C14.4995 3.28429 14.3151 2.83917 13.9869 2.51098C13.6588 2.18279 13.2136 1.99841 12.7495 1.99841H3.74951ZM19.9995 9.99841V19.2484H14.4995V9.99841H19.9995ZM12.4995 8.99841L12.4995 19.2484H3.99951V3.99841H12.4995L12.4995 8.99841Z" fill="#252628"/>
            </svg>
            <span>{{data.props.rooms}} комнаты</span>
          </p>
          <p class="collateral-item-page__character-block" v-if="data.props.area">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3861 1.21065C11.7472 0.929784 12.2528 0.929784 12.6139 1.21065L21.6139 8.21065C21.8575 8.4001 22 8.69141 22 9V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V9C2 8.69141 2.14247 8.4001 2.38606 8.21065L11.3861 1.21065ZM10 21H14V13H10V21ZM16 21V12C16 11.4477 15.5523 11 15 11H9C8.44772 11 8 11.4477 8 12V21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V9.48908L12 3.26686L20 9.48908V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H16Z" fill="#252628"/>
            </svg>
            <span>{{data.props.area}} м<sup>2</sup></span></p>
          <p class="collateral-item-page__character-block" v-if="data.props.floor && data.props.floors_count">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.7159 10.4534C20.7159 10.8321 20.7159 11.2131 20.7159 11.5917C20.7159 12.5072 20.7159 13.4226 20.7159 14.3357C20.7159 15.4381 20.7159 16.5428 20.7159 17.6452C20.7159 18.599 20.7159 19.5528 20.7159 20.5066C20.7159 20.9715 20.7057 21.4364 20.7159 21.9014C20.7159 21.9085 20.7159 21.9133 20.7159 21.9205C21.096 21.5611 21.4761 21.2016 21.8562 20.8421C21.6814 20.8421 21.504 20.8421 21.3291 20.8421C20.8502 20.8421 20.3738 20.8421 19.8948 20.8421C19.1878 20.8421 18.4807 20.8421 17.7737 20.8421C16.9121 20.8421 16.0479 20.8421 15.1863 20.8421C14.2411 20.8421 13.2958 20.8421 12.3506 20.8421C11.3977 20.8421 10.4423 20.8421 9.48948 20.8421C8.59999 20.8421 7.71049 20.8421 6.821 20.8421C6.06835 20.8421 5.31823 20.8421 4.56558 20.8421C4.0258 20.8421 3.48349 20.8421 2.94371 20.8421C2.68776 20.8421 2.42927 20.8397 2.17332 20.8421C2.16319 20.8421 2.15051 20.8421 2.14038 20.8421C2.5205 21.2016 2.90063 21.5611 3.28076 21.9205C3.28076 20.7798 3.28076 19.6367 3.28076 18.496C3.28076 18.333 3.28076 18.1724 3.28076 18.0095C2.90063 18.369 2.5205 18.7284 2.14038 19.0879C2.86262 19.0879 3.58486 19.0879 4.3071 19.0879C5.45761 19.0879 6.60559 19.0879 7.75611 19.0879C8.01713 19.0879 8.28068 19.0879 8.5417 19.0879C9.1575 19.0879 9.68208 18.5942 9.68208 18.0095C9.68208 16.9047 9.68208 15.8023 9.68208 14.6976C9.68208 14.5418 9.68208 14.386 9.68208 14.2326C9.30195 14.5921 8.92182 14.9516 8.5417 15.3111C9.26394 15.3111 9.98871 15.3111 10.711 15.3111C11.8589 15.3111 13.0069 15.3111 14.1549 15.3111C14.4184 15.3111 14.682 15.3111 14.9481 15.3111C15.5639 15.3111 16.0885 14.8174 16.0885 14.2326C16.0885 13.1279 16.0885 12.0255 16.0885 10.9207C16.0885 10.765 16.0885 10.6092 16.0885 10.4558C15.7083 10.8153 15.3282 11.1748 14.9481 11.5342C15.7286 11.5342 16.5117 11.5342 17.2922 11.5342C18.5289 11.5342 19.763 11.5342 20.9997 11.5342C21.2861 11.5342 21.5699 11.5342 21.8562 11.5342C22.1477 11.5342 22.4568 11.4144 22.6621 11.2179C22.8598 11.031 23.0093 10.7242 22.9966 10.4558C22.984 10.1778 22.8877 9.88785 22.6621 9.69374C22.4391 9.49962 22.1654 9.3774 21.8562 9.3774C21.0757 9.3774 20.2927 9.3774 19.5121 9.3774C18.2755 9.3774 17.0413 9.3774 15.8046 9.3774C15.5183 9.3774 15.2345 9.3774 14.9481 9.3774C14.3323 9.3774 13.8077 9.87107 13.8077 10.4558C13.8077 11.5606 13.8077 12.663 13.8077 13.7677C13.8077 13.9235 13.8077 14.0793 13.8077 14.2326C14.1878 13.8732 14.568 13.5137 14.9481 13.1542C14.2259 13.1542 13.5011 13.1542 12.7788 13.1542C11.6309 13.1542 10.4829 13.1542 9.3349 13.1542C9.07134 13.1542 8.80779 13.1542 8.5417 13.1542C7.9259 13.1542 7.40132 13.6479 7.40132 14.2326C7.40132 15.3374 7.40132 16.4398 7.40132 17.5446C7.40132 17.7003 7.40132 17.8561 7.40132 18.0095C7.78145 17.65 8.16157 17.2905 8.5417 16.9311C7.81946 16.9311 7.09722 16.9311 6.37498 16.9311C5.22447 16.9311 4.07649 16.9311 2.92597 16.9311C2.66495 16.9311 2.4014 16.9311 2.14038 16.9311C1.52457 16.9311 1 17.4247 1 18.0095C1 19.1502 1 20.2933 1 21.434C1 21.597 1 21.7576 1 21.9205C1 22.5029 1.52204 22.9989 2.14038 22.9989C2.31524 22.9989 2.49263 22.9989 2.66749 22.9989C3.14644 22.9989 3.62287 22.9989 4.10183 22.9989C4.80886 22.9989 5.5159 22.9989 6.22293 22.9989C7.08455 22.9989 7.9487 22.9989 8.81032 22.9989C9.75557 22.9989 10.7008 22.9989 11.6461 22.9989C12.5989 22.9989 13.5543 22.9989 14.5071 22.9989C15.3966 22.9989 16.2861 22.9989 17.1756 22.9989C17.9283 22.9989 18.6784 22.9989 19.431 22.9989C19.9708 22.9989 20.5131 22.9989 21.0529 22.9989C21.3089 22.9989 21.5673 23.0013 21.8233 22.9989C21.8334 22.9989 21.8461 22.9989 21.8562 22.9989C22.472 22.9989 22.9966 22.5053 22.9966 21.9205C22.9966 21.5419 22.9966 21.1608 22.9966 20.7822C22.9966 19.8667 22.9966 18.9513 22.9966 18.0382C22.9966 16.9359 22.9966 15.8311 22.9966 14.7287C22.9966 13.7749 22.9966 12.8211 22.9966 11.8673C22.9966 11.4024 23.0042 10.9375 22.9966 10.4726C22.9966 10.4654 22.9966 10.4606 22.9966 10.4534C22.9966 10.1778 22.8699 9.88545 22.6621 9.69134C22.4644 9.50441 22.1401 9.36302 21.8562 9.375C21.5623 9.38699 21.2556 9.47805 21.0504 9.69134C20.8451 9.89983 20.7159 10.161 20.7159 10.4534Z" fill="#252628"/>
              <path d="M2.71563 13.6887C2.85248 13.6 2.98679 13.5089 3.12363 13.4203C3.49362 13.1758 3.86361 12.9314 4.23107 12.6869C4.77845 12.3251 5.3233 11.9656 5.87068 11.6037C6.53716 11.1628 7.20365 10.7218 7.87014 10.2809C8.59998 9.7992 9.32982 9.31511 10.0622 8.83342C10.7996 8.34694 11.5371 7.85806 12.2745 7.37157C12.9613 6.91624 13.6506 6.46331 14.3373 6.00798C14.9177 5.62454 15.498 5.24111 16.0809 4.85767C16.4965 4.58208 16.9121 4.30888 17.3302 4.03329C17.5279 3.90148 17.7281 3.77207 17.9257 3.64027C17.9333 3.63547 17.9435 3.62828 17.9511 3.62349C18.1994 3.46053 18.392 3.26162 18.4757 2.97884C18.5517 2.72002 18.5162 2.37732 18.3616 2.14726C18.2045 1.9172 17.9714 1.7135 17.6799 1.65119C17.3936 1.58889 17.0515 1.59608 16.8006 1.75904C16.6637 1.8477 16.5294 1.93877 16.3926 2.02744C16.0226 2.27188 15.6526 2.51632 15.2851 2.76076C14.7378 3.12263 14.1929 3.4821 13.6455 3.84397C12.979 4.28492 12.3125 4.72587 11.6461 5.16682C10.9162 5.64851 10.1864 6.1326 9.454 6.61429C8.71655 7.10077 7.97911 7.58965 7.24166 8.07613C6.5549 8.53146 5.86561 8.9844 5.17885 9.43973C4.59852 9.82316 4.0182 10.2066 3.43534 10.59C3.01973 10.8656 2.60413 11.1388 2.18599 11.4144C1.98832 11.5462 1.78812 11.6756 1.59046 11.8074C1.58286 11.8122 1.57272 11.8194 1.56512 11.8242C1.31677 11.9872 1.12417 12.1861 1.04054 12.4689C0.964517 12.7277 0.999995 13.0704 1.15458 13.3004C1.3117 13.5305 1.54484 13.7342 1.83627 13.7965C2.12263 13.8588 2.46728 13.854 2.71563 13.6887Z" fill="#252628"/>
              <path d="M13.0601 3.10824C14.2309 3.28558 15.4042 3.46531 16.575 3.64265C16.7397 3.66901 16.907 3.69298 17.0717 3.71934C16.8056 3.27599 16.5395 2.83504 16.276 2.39169C16.0885 3.49886 15.8984 4.60843 15.7109 5.7156C15.683 5.87137 15.6576 6.02954 15.6298 6.18531C15.5791 6.48007 15.5791 6.74848 15.7438 7.01688C15.8832 7.23975 16.1543 7.45304 16.4255 7.51295C16.7169 7.57526 17.0438 7.56328 17.3049 7.40511C17.538 7.26132 17.7838 7.03126 17.8294 6.76046C18.017 5.65329 18.207 4.54372 18.3946 3.43655C18.4224 3.28078 18.4478 3.12262 18.4756 2.96685C18.5238 2.68406 18.5339 2.3893 18.3616 2.13527C18.2096 1.91479 17.9663 1.68234 17.6799 1.6392C16.5091 1.46186 15.3358 1.28213 14.165 1.10479C14.0003 1.07843 13.833 1.05446 13.6683 1.0281C13.3566 0.980171 13.0728 0.980171 12.789 1.13594C12.5533 1.26775 12.3277 1.52417 12.2644 1.78059C12.1985 2.05619 12.2112 2.36533 12.3784 2.61217C12.5279 2.83504 12.7712 3.0651 13.0601 3.10824Z" fill="#252628"/>
            </svg>
            <span>  {{ getFloorsLabel(data.props.object_type, data.props.floor, data.props.floors_count) }}</span>
          </p>
          <p class="collateral-item-page__character-block" v-if="data.props.section_area">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_1644_7395)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H6C6.40446 3 6.7691 3.24364 6.92388 3.61732C7.07866 3.99099 6.9931 4.42111 6.70711 4.70711L4.70711 6.70711C4.42111 6.9931 3.99099 7.07866 3.61732 6.92388C3.24364 6.7691 3 6.40446 3 6V5C3 4.46957 3.21071 3.96086 3.58579 3.58579ZM10 4C10 3.44772 10.4477 3 11 3H13C13.5523 3 14 3.44772 14 4C14 4.55228 13.5523 5 13 5H11C10.4477 5 10 4.55228 10 4ZM17.0761 3.61732C17.2309 3.24364 17.5955 3 18 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V6C21 6.40446 20.7564 6.7691 20.3827 6.92388C20.009 7.07866 19.5789 6.9931 19.2929 6.70711L17.2929 4.70711C17.0069 4.42111 16.9213 3.99099 17.0761 3.61732ZM4 10C4.55228 10 5 10.4477 5 11V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11C3 10.4477 3.44772 10 4 10ZM19 11C19 10.4477 19.4477 10 20 10C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V11ZM3.61732 17.0761C3.99099 16.9213 4.42111 17.0069 4.70711 17.2929L6.70711 19.2929C6.9931 19.5789 7.07866 20.009 6.92388 20.3827C6.7691 20.7564 6.40446 21 6 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V18C3 17.5955 3.24364 17.2309 3.61732 17.0761ZM20.3827 17.0761C20.7564 17.2309 21 17.5955 21 18V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H18C17.5955 21 17.2309 20.7564 17.0761 20.3827C16.9213 20.009 17.0069 19.5789 17.2929 19.2929L19.2929 17.2929C19.5789 17.0069 20.009 16.9213 20.3827 17.0761ZM10 20C10 19.4477 10.4477 19 11 19H13C13.5523 19 14 19.4477 14 20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20Z" fill="#252628"/>
              </g>
              <defs>
                <clipPath id="clip0_1644_7395">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span>{{data.props.section_area}} м<sup>2</sup></span></p>
        </div>
        <div class="collateral-item-page__block-cadastr" v-if="data.props.cadastral_numbers">
          <p class="collateral-item-page__cadastr">
            Кадастровый номер: {{data.props.cadastral_numbers}}
          </p>
        </div>
        <div class="collateral-item-page__block-date" v-if="data.props.auction_date && data.props.auction_deadline">
          <div class="collateral-item-page__date">
            <p class="collateral-item-page__date-title">Окончание приема заявок:</p>
            <time class="collateral-item-page__date-time">{{data.props.auction_deadline}}</time>
          </div>
          <div class="collateral-item-page__date">
            <p class="collateral-item-page__date-title">Проведение торгов:</p>
            <time class="collateral-item-page__date-time">{{data.props.auction_date}}</time>
          </div>
        </div>
        <a class="collateral-item-page__link-blank" href="/upload/land/property/tipovay_forma_kp_i_sopd.docx">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 15.0033C3.55228 15.0033 4 15.451 4 16.0033V21.0033H20V16.0033C20 15.451 20.4477 15.0033 21 15.0033C21.5523 15.0033 22 15.451 22 16.0033V21.2533C22 21.7824 21.7464 22.2437 21.3766 22.5518C21.0121 22.8556 20.5509 23.0033 20.1 23.0033H3.9C3.44908 23.0033 2.98792 22.8556 2.62342 22.5518C2.2536 22.2437 2 21.7824 2 21.2533V16.0033C2 15.451 2.44772 15.0033 3 15.0033Z" fill="#82BF00"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0114 16.4033C11.4591 16.4033 11.0114 15.9556 11.0114 15.4033V3.40332C11.0114 2.85104 11.4591 2.40332 12.0114 2.40332C12.5637 2.40332 13.0114 2.85104 13.0114 3.40332V15.4033C13.0114 15.9556 12.5637 16.4033 12.0114 16.4033Z" fill="#82BF00"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7124 16.2108C12.322 16.6008 11.6894 16.6008 11.299 16.2108L6.76399 11.6808C6.37325 11.2905 6.3729 10.6573 6.76321 10.2666C7.15352 9.87584 7.78668 9.87549 8.17742 10.2658L12.0057 14.0899L15.834 10.2658C16.2247 9.87549 16.8579 9.87584 17.2482 10.2666C17.6385 10.6573 17.6382 11.2905 17.2474 11.6808L12.7124 16.2108Z" fill="#82BF00"/>
          </svg>
          <span>Заявление на покупку</span>
        </a>
        <div class="collateral-item-page__block-buttons">
          <a class="collateral-item-page__button js--anchor" href="#question">Задать вопрос</a>
          <a class="collateral-item-page__button collateral-item-page__button_auction" target="_blank" :href="data.props.auction_link" v-if="data.props.is_auction">
            <span>Учавствовать в торгах</span>
            <div class="collateral-item-page__tooltip">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <g clip-path="url(#clip0_1326_30231)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.583984 6.99967C0.583984 10.5435 3.45682 13.4163 7.00065 13.4163C10.5445 13.4163 13.4173 10.5435 13.4173 6.99967C13.4173 3.45585 10.5445 0.583008 7.00065 0.583008C3.45682 0.583008 0.583984 3.45585 0.583984 6.99967ZM12.2506 6.99969C12.2506 9.89918 9.90014 12.2497 7.00064 12.2497C4.10115 12.2497 1.75064 9.89918 1.75064 6.99969C1.75064 4.10019 4.10115 1.74969 7.00064 1.74969C9.90014 1.74969 12.2506 4.10019 12.2506 6.99969Z" fill="white"/>
                  <path d="M6.53211 8.17602C6.53211 7.93968 6.58283 7.71945 6.68428 7.51534C6.78573 7.31123 6.90854 7.13666 7.0527 6.99163C7.19687 6.8466 7.34103 6.70963 7.4852 6.58072C7.62936 6.44643 7.75217 6.30141 7.85362 6.14564C7.95507 5.98449 8.00579 5.81529 8.00579 5.63804C8.00579 5.36947 7.91235 5.16536 7.72547 5.0257C7.54393 4.88067 7.30633 4.80816 7.01266 4.80816C6.42532 4.80816 6.04889 5.06867 5.88337 5.5897L5.25064 5.23518C5.38413 4.85919 5.61106 4.5745 5.93142 4.38113C6.25179 4.18239 6.61487 4.08302 7.02067 4.08302C7.49588 4.08302 7.90167 4.2173 8.23806 4.48587C8.57978 4.75444 8.75064 5.12776 8.75064 5.60581C8.75064 5.83141 8.69992 6.04358 8.59847 6.24232C8.49702 6.44106 8.37422 6.61295 8.23005 6.75797C8.08589 6.903 7.94172 7.04534 7.79756 7.185C7.65339 7.31928 7.53058 7.47237 7.42913 7.64425C7.32768 7.81077 7.27696 7.98802 7.27696 8.17602H6.53211ZM6.90053 9.91635C6.75637 9.91635 6.63356 9.86532 6.53211 9.76327C6.43066 9.66121 6.37994 9.53767 6.37994 9.39264C6.37994 9.24761 6.43066 9.12407 6.53211 9.02202C6.63356 8.91996 6.75637 8.86893 6.90053 8.86893C7.05003 8.86893 7.17284 8.91996 7.26895 9.02202C7.3704 9.12407 7.42112 9.24761 7.42112 9.39264C7.42112 9.53767 7.3704 9.66121 7.26895 9.76327C7.17284 9.86532 7.05003 9.91635 6.90053 9.91635Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_1326_30231">
                    <rect width="14" height="14" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              <div class="collateral-item-page__tooltip-text">
                  Переход на торговую площадку, на которой необходима авторизация. С правилами покупки на торгах вы можете ознакомиться ниже.
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="collateral-item-page__block-map">
      <div class="collateral-item-page__map-controls-container">
        <button class="collateral-item-page__map-plus" @click="zoomPlus">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 11.0001V2.00006H13V11.0001L22 11.0001V13.0001L13 13.0001V22.0001H11V13.0001L2 13.0001V11.0001L11 11.0001Z" fill="#252628"/>
          </svg>
        </button>
        <button class="collateral-item-page__map-minus" @click="zoomMinus">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12.9999H2V10.9999H22V12.9999Z" fill="#252628"/>
          </svg>
        </button>
        <button class="collateral-item-page__map-geo" @click="setCenter">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12.5 24L9.46891 18.75H15.5311L12.5 24Z" fill="#252628"/>
            <circle cx="12" cy="10" r="8.5" stroke="#252628" stroke-width="3"/>
          </svg>
        </button>
      </div>
      <yandex-map
          :settings='mapSettings'
          :zoom='zoom'
          :coords='center'
          :controls='[]'
          :options='mapOptions'
          class="collateral-item-page__map"
          @map-was-initialized='initMapHandler'>
        <ymap-marker
            :coords='center'
            :marker-id='data.id'
            :icon="{
                layout: 'default#imageWithContent',
                content: '',
                imageSize: [20, 20],
                imageOffset: [-10, -10],
                contentOffset: [-40, -22],
                contentLayout: `<div style='background: transparent; width: 72px; height: 72px; border-radius: 100%;'><img style='width: 72px; height: 72px; border-radius: 100%;  border: 4px solid white;' width='72px' height='72px'  src='${this.data.picture}' /></div>`
            }"
            cluster-name='map-cluster'
            :imageHref="data.picture"
             />
      </yandex-map>
    </div>
    <div class="collateral-item-page__wrapper" v-if="!data.props.is_auction">
      <div class="collateral-property__ways">
        <h3 id="withoutAuction" class="collateral-property__ways-title">Покупка недвижимого имущества без аукциона</h3>
        <p class="collateral-property__ways-desc">Для покупки объектов недвижимости без аукциона необходимо сделать 4 шага: </p>
        <div class="collateral-property__ways-container">
          <div class="collateral-property__ways-block">
            <div class="collateral-property__ways-point">
              01
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36" stroke-dashoffset="382" stroke="#D9F0AB"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text">Выбор объекта</p>
          </div>
          <div class="collateral-property__ways-block">
            <div class="collateral-property__ways-point">
              02
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36" stroke-dashoffset="333" stroke="#A3D562"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text">Подача заявки на обратную связь</p>
          </div>
          <div class="collateral-property__ways-block">
            <div class="collateral-property__ways-point">
              03
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36"  stroke-dashoffset="282" stroke="#82BF00"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text">Осмотр объекта</p>
          </div>
          <div class="collateral-property__ways-block">
            <div class="collateral-property__ways-point">
              04
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36"  stroke-dashoffset="226" stroke="#699b12"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text">Подписание договора</p>
          </div>
        </div>
      </div>
      <div class="collateral-property__pay">
        <h3 class="collateral-property__pay-title">Принимаем к оплате</h3>
        <div class="collateral-property__pay-points">
          <p class="collateral-property__pay-point">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.0017C15.5228 20.0017 20 15.5246 20 10.0017C20 4.47886 15.5228 0.00170898 10 0.00170898C4.47715 0.00170898 0 4.47886 0 10.0017C0 15.5246 4.47715 20.0017 10 20.0017ZM13.1655 7.37548C13.556 6.98496 14.1892 6.98496 14.5797 7.37548L14.7369 7.53262C15.1274 7.92314 15.1274 8.55631 14.7369 8.94683L10.7299 12.9538L9.15857 11.3824L13.1655 7.37548ZM10.7299 12.9538L9.15849 14.5251L5.15155 10.5182C4.76103 10.1277 4.76103 9.49449 5.15155 9.10397L5.30869 8.94683C5.69921 8.55631 6.33237 8.5563 6.7229 8.94682L10.7299 12.9538Z" fill="#82BF00"/>
            </svg>
            <span>
                        Ипотека
                    </span>
          </p>
          <p class="collateral-property__pay-point">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.0017C15.5228 20.0017 20 15.5246 20 10.0017C20 4.47886 15.5228 0.00170898 10 0.00170898C4.47715 0.00170898 0 4.47886 0 10.0017C0 15.5246 4.47715 20.0017 10 20.0017ZM13.1655 7.37548C13.556 6.98496 14.1892 6.98496 14.5797 7.37548L14.7369 7.53262C15.1274 7.92314 15.1274 8.55631 14.7369 8.94683L10.7299 12.9538L9.15857 11.3824L13.1655 7.37548ZM10.7299 12.9538L9.15849 14.5251L5.15155 10.5182C4.76103 10.1277 4.76103 9.49449 5.15155 9.10397L5.30869 8.94683C5.69921 8.55631 6.33237 8.5563 6.7229 8.94682L10.7299 12.9538Z" fill="#82BF00"/>
            </svg>
            <span>
                        Материнский капитал
                    </span>
          </p>
          <p class="collateral-property__pay-point">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.0017C15.5228 20.0017 20 15.5246 20 10.0017C20 4.47886 15.5228 0.00170898 10 0.00170898C4.47715 0.00170898 0 4.47886 0 10.0017C0 15.5246 4.47715 20.0017 10 20.0017ZM13.1655 7.37548C13.556 6.98496 14.1892 6.98496 14.5797 7.37548L14.7369 7.53262C15.1274 7.92314 15.1274 8.55631 14.7369 8.94683L10.7299 12.9538L9.15857 11.3824L13.1655 7.37548ZM10.7299 12.9538L9.15849 14.5251L5.15155 10.5182C4.76103 10.1277 4.76103 9.49449 5.15155 9.10397L5.30869 8.94683C5.69921 8.55631 6.33237 8.5563 6.7229 8.94682L10.7299 12.9538Z" fill="#82BF00"/>
            </svg>
            <span>
                        Федеральное региональное субсидирование
                    </span>
          </p>
        </div>
      </div>
    </div>
    <div class="collateral-item-page__wrapper" v-else>
      <div class="collateral-property__ways">
        <h3 id="withAuction" class="collateral-property__ways-title">Покупка недвижимого имущества на аукционе</h3>
        <p class="collateral-property__ways-desc">Принять участие в аукционах могут все желающие. <br>Для этого необходимо сделать 3 шага: </p>
        <div class="collateral-property__ways-container">
          <div class="collateral-property__ways-block collateral-property__ways-block_mini">
            <div class="collateral-property__ways-point">
              01
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36" stroke-dashoffset="375" stroke="#D9F0AB"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text">Получить <br> <a href="https://cert.sberbank-ast.ru/" target="_blank">электронный ключ</a></p>
          </div>
          <div class="collateral-property__ways-block collateral-property__ways-block_mini" >
            <div class="collateral-property__ways-point">
              02
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36"  stroke-dashoffset="300" stroke="#82BF00"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text"><a href="https://utp.sberbank-ast.ru/Main/NBT/RegistrPage/0/0/0/0" target="_blank">Зарегистрироваться</a> на сайте <br> Сбербанка-АСТ как физ. или юр. лицо с<br> электронной подписью</p>
          </div>
          <div class="collateral-property__ways-block collateral-property__ways-block_mini" >
            <div class="collateral-property__ways-point">
              03
              <svg>
                <circle r="34" cy="36" cx="36"></circle>
                <circle r="34" cy="36" cx="36"  stroke-dashoffset="226" stroke="#699b12"></circle>
              </svg>
            </div>
            <p class="collateral-property__ways-point-text"><a href="https://www.sberbank-ast.ru/UnitedPurchaseList.aspx" target="_blank">Подать заявку</a> на участие в аукционе</p>
          </div>
        </div>
      </div>
      <div class="collateral-property__pay">
        <h3 class="collateral-property__pay-title">Оплата</h3>
        <div class="collateral-property__pay-points">
          <p class="collateral-property__pay-point">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20.0017C15.5228 20.0017 20 15.5246 20 10.0017C20 4.47886 15.5228 0.00170898 10 0.00170898C4.47715 0.00170898 0 4.47886 0 10.0017C0 15.5246 4.47715 20.0017 10 20.0017ZM13.1655 7.37548C13.556 6.98496 14.1892 6.98496 14.5797 7.37548L14.7369 7.53262C15.1274 7.92314 15.1274 8.55631 14.7369 8.94683L10.7299 12.9538L9.15857 11.3824L13.1655 7.37548ZM10.7299 12.9538L9.15849 14.5251L5.15155 10.5182C4.76103 10.1277 4.76103 9.49449 5.15155 9.10397L5.30869 8.94683C5.69921 8.55631 6.33237 8.5563 6.7229 8.94682L10.7299 12.9538Z" fill="#82BF00"/>
            </svg>
            <span>
                        Покупка недвижимости на аукционе возможна только с использованием собственных средств покупателя
                    </span>
          </p>
        </div>
      </div>
    </div>
    <div class="collateral-item-page__wrapper" id="question">
      <collateral-property-form :additional-fields="{
				'form[APPLICATION]': data.name,
				'form[REGION]': data.region.name,
				'form[CITY]': data.props.city
      }"/>
    </div>
    <div class="collateral-item-page__wrapper collateral-item-page__wrapper_similar" v-if="data.similars.length">
      <h3 class="collateral-item-page__similar-title">Похожие объекты</h3>
      <div class="collateral-item-page__similar-container">
        <offer-card v-for="(item, index) in data.similars"
          :key="item.id"
          :cardData="item"
          @offer-chosen="showFormFeedback"
          @add-to-favorite="showFavoriteWarn = true"
        />
      </div>
    </div>
  </div>
  <Transition>
    <form-feedback
        v-if="formFeedbackVisible && currentOffer"
        :offer="currentOffer"
        @hide-modal="hideFeedbackForm" />
  </Transition>
  <favorite-warn
        v-if="showFavoriteWarn"
        @hide-warn="showFavoriteWarn = false" />
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import { Autoplay, EffectFade, Navigation, Thumbs } from 'swiper';
import CollateralPropertyForm from './CollateralPropertyForm'
import OfferCard from '../land/property/components/OfferCard'
import {getCookie, setCookie, deleteCookie} from '../modules/cookie-helper.js'
import FormFeedback from '../land/property/components/FormFeedback'
import declineWordOfNum from '../modules/decline-word-of-num.js'
import anchorLinks from '../modules/anchor-links.js'
import FavoriteWarn from '../land/property/components/FavoriteWarn'

export default {
  name: 'CollateralItemPage',
  props: ['data'],
  components: {
    Swiper,
    SwiperSlide,
    CollateralPropertyForm,
    yandexMap,
    ymapMarker,
    OfferCard,
    FormFeedback,
    FavoriteWarn
  },
  emits: [],
  data(){
    return{
      sliderIndex: '1',
      thumbsSwiper: null,
      setThumbsSwiper: (swiper) => {
        this.thumbsSwiper = swiper
      },
      zoom: 15,
      formFeedbackVisible: false,
      currentOffer: null,
      mapOptions: { suppressMapOpenBlock: true, minZoom: 3, maxZoom: 23 },
      center: [this.data.props.latitude, this.data.props.longitude],
      isLoading: true,
      mapInstance: null,
      priceContainerActive: false,
      markerDefaultIcon: {
        layout: 'default#imageWithContent',
        imageHref: this.data.picture,
        content: '',
        imageSize: [20, 20],
        imageOffset: [-10, -10],
        contentOffset: [-40, -22],
        contentLayout: '<div style="background: white; width: 100px; color: #252628; font-weight: 600; padding: 2px; border-radius: 4px; box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);"><img :src=`${$[properties.imageHref]}` /></div>'
      },
      mapSettings: {
        apiKey: '07ce8f81-4778-4452-b6a8-b99ae4ad1522',
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1',
      },
      isFavorite: false,
      showFavoriteWarn: false
    }
  },
  setup (){
    return {
      modules: [Autoplay, EffectFade, Navigation, Thumbs]
    }
  },
  methods:{
    checkDiff(item){
      if(item === 0){
        return ''
      } else {
        const result =  String(item)[0] === '-' ? '+' + this.formatNumbers(item * -1) +' ₽' : '-' + this.formatNumbers(item) +' ₽';
        return result
      }
    },
    showFormFeedback (offer) {
      this.currentOffer = offer
      this.formFeedbackVisible = true
    },
    hideFeedbackForm () {
      this.currentOffer = null
      this.formFeedbackVisible = false
    },
    setPriceActive(){
      this.priceContainerActive = !this.priceContainerActive
    },
    formatWordOfNum (num, textArr) {
      return declineWordOfNum(num, textArr)
    },
    getFloorsLabel(type, floor, floormax) {
      if (type === 'FLAT') {
        return `${floor}/${floormax} этаж`
      }

      if (!type) {
        return `${floor} этаж`
      }

      return `${floormax} ${this.formatWordOfNum(floormax, ['этаж', 'этажа', 'этажей'])}`
    },

    favoriteHandler () {
      const coocieFavorite = getCookie('favorite')
      setTimeout(() => {
        if (coocieFavorite.split(',').includes(this.data.id)) {
          this.isFavorite = false
          const newVal = coocieFavorite.split(',').filter(el => el !== this.data.id)
          deleteCookie('favorite')
          setCookie('favorite', newVal)
          return
        }

        this.showFavoriteWarn = true

        this.isFavorite = true
        if (!coocieFavorite) {
          setCookie('favorite', this.data.id)
          return
        }

        setCookie('favorite', [coocieFavorite, this.data.id])
      }, 0)
    },
    zoomPlus(){
      this.zoom += 1;
    },
    zoomMinus(){
      this.zoom -= 1;
    },
    setCenter(){
      this.center = [this.data.props.latitude, this.data.props.longitude]
    },
    formatNumbers (number) {
      return new Intl.NumberFormat("ru-RU").format(number)
    },
    initMapHandler(payload) {
      this.mapInstance = payload;
      window.domYMAPS = payload;
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    slideChange(e){
      this.sliderIndex = Number(e.realIndex + 1)
    }
  },
  mounted(){
    anchorLinks();
    const coocieFavorite = getCookie('favorite')
    if (coocieFavorite === this.data.id) {
      this.isFavorite = true
      return
    }

    const favoritesId = coocieFavorite?.split(',')
    if (favoritesId && favoritesId.includes(this.data.id)) {
      this.isFavorite = true
      return
    }
  }
}
</script>
